import { render } from "./SoundtracksPage.vue?vue&type=template&id=5036dc87&scoped=true"
import script from "./SoundtracksPage.vue?vue&type=script&lang=js"
export * from "./SoundtracksPage.vue?vue&type=script&lang=js"

import "./SoundtracksPage.vue?vue&type=style&index=0&id=5036dc87&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5036dc87"]])

export default __exports__